import {h, Fragment} from "preact"
import { useProductFilters } from "@nosto/preact"

function FilterRemoveButton({ filter, className }) {
    return (
        <button
            className={`ns-act-btn ns-text-align-right ns-align-items-center ns-clickable ns-p-1 ns-color-black ${className}`}
            onClick={() => filter.remove()}
        >
            <svg aria-hidden="true" focusable="false" role="presentation" width="12" height="12" class="icon icon-close-small" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8.48627 9.32917L2.82849 3.67098" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path>
                <path d="M2.88539 9.38504L8.42932 3.61524" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>
        </button>
    )
}

export default function SelectedFilters() {
    const { filters, removeAll } = useProductFilters()

    return (
        filters.length > 0 && (
            <div class="flex gap-12 mx-8 my-12 overflow-x-scroll no-scrollbar uppercase lg:hidden">
                <span
                    class="flex items-center whitespace-nowrap"
                    onClick={() => {
                        removeAll()
                    }}
                >
                    Clear Filters
                </span>

                <div class="ns-col-10 ns-d-flex ns-flex-wrap ns-align-items-center">
                    {filters.map(filter => (
                        <div
                            key={`${filter.name}: ${filter.value}`}
                            class="flex items-center gap-2 whitespace-nowrap"
                        >
                            <span class="text-black">
                                {filter.value}
                            </span>
                            <FilterRemoveButton filter={filter} />
                        </div>
                    ))}
                </div>
            </div>
        )
    )
}
